import type { SVGProps } from 'react';

const Dots = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13 6.25C13 6.66421 12.6642 7 12.25 7C11.8358 7 11.5 6.66421 11.5 6.25C11.5 5.83579 11.8358 5.5 12.25 5.5C12.6642 5.5 13 5.83579 13 6.25Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 12.25C13 12.6642 12.6642 13 12.25 13C11.8358 13 11.5 12.6642 11.5 12.25C11.5 11.8358 11.8358 11.5 12.25 11.5C12.6642 11.5 13 11.8358 13 12.25Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 6.25C19 6.66421 18.6642 7 18.25 7C17.8358 7 17.5 6.66421 17.5 6.25C17.5 5.83579 17.8358 5.5 18.25 5.5C18.6642 5.5 19 5.83579 19 6.25Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 12.25C19 12.6642 18.6642 13 18.25 13C17.8358 13 17.5 12.6642 17.5 12.25C17.5 11.8358 17.8358 11.5 18.25 11.5C18.6642 11.5 19 11.8358 19 12.25Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 6.25C7 6.66421 6.66421 7 6.25 7C5.83579 7 5.5 6.66421 5.5 6.25C5.5 5.83579 5.83579 5.5 6.25 5.5C6.66421 5.5 7 5.83579 7 6.25Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 12.25C7 12.6642 6.66421 13 6.25 13C5.83579 13 5.5 12.6642 5.5 12.25C5.5 11.8358 5.83579 11.5 6.25 11.5C6.66421 11.5 7 11.8358 7 12.25Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 18.25C13 18.6642 12.6642 19 12.25 19C11.8358 19 11.5 18.6642 11.5 18.25C11.5 17.8358 11.8358 17.5 12.25 17.5C12.6642 17.5 13 17.8358 13 18.25Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 18.25C19 18.6642 18.6642 19 18.25 19C17.8358 19 17.5 18.6642 17.5 18.25C17.5 17.8358 17.8358 17.5 18.25 17.5C18.6642 17.5 19 17.8358 19 18.25Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 18.25C7 18.6642 6.66421 19 6.25 19C5.83579 19 5.5 18.6642 5.5 18.25C5.5 17.8358 5.83579 17.5 6.25 17.5C6.66421 17.5 7 17.8358 7 18.25Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Dots;
